import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { canManageWorkDuty } from "../../utils/userUtils";

const WorkDutyRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return canManageWorkDuty(user) ? children : <Navigate to="/" replace />;
};

export default WorkDutyRoute;
